import MaterialityAssessmentContainer from "./containers/MaterialityAssessmentContainer";
export default MaterialityAssessmentContainer;
